import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import XIcon from "@mui/icons-material/X";
import CodeIcon from "@mui/icons-material/Code"; // 👈 Ícono </>
import { jsPDF } from "jspdf";

// =========================================
// 📄 Función para descargar el README en PDF
// =========================================
const descargarReadme = () => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });

  const contenido = `
 Guía de Deploy – Plataforma de Datos para la Democracia

Repositorio oficial: https://github.com/datosnodoxxi/plataforma-datos

------------------------------------------------------------

 Estructura general
- Frontend (React) → integrado en WordPress
- Backend (Node.js + Express) → expuesto bajo /api
Ruta final: https://www.nodoxxi.cl/datosparalademocracia/

------------------------------------------------------------

 Requerimientos técnicos
- Node.js v20.x
- npm v10.x
- Nginx reverse proxy
- WordPress 6.8+

------------------------------------------------------------

 Backend – Despliegue
cd backend
npm ci
pm2 start index.js --name datos-api
pm2 save

Configurar CORS:
app.use(cors({ origin: ['https://www.nodoxxi.cl'] }));

Nginx location:
location /api/ {
  proxy_pass http://127.0.0.1:5000/;
}

------------------------------------------------------------

 Frontend – Compilación
REACT_APP_API_BASE_URL=https://www.nodoxxi.cl/api npm run build

Plugin WordPress:
[plataforma_datos]

------------------------------------------------------------

 Checklist
- API operativa
- Página carga correctamente
- Gráficos funcionando
- SSL OK
`;

  doc.setFont("Helvetica", "normal");
  doc.setFontSize(11);

  const margin = 40;
  const maxWidth = 520;

  doc.text(contenido, margin, margin, { maxWidth, lineHeightFactor: 1.4 });

  doc.save("README-DEPLOY.pdf");
};

// =========================================
// Footer principal
// =========================================

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#e6e6e6",
        color: "white",
        px: 3,
        py: 5,
        position: "relative",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        overflow: "visible",
        marginTop: "100px",
      }}
    >
      {/* Logo + texto */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <img
          src="/img/logoNodo_COLOR.png"
          alt="Logo Nodo XXI Blanco"
          style={{ height: "60px", objectFit: "contain" }}
        />
        <Typography variant="body2" sx={{ fontFamily: "Poppins, sans-serif", color: "black" }}>
          Desarrollado por Integratek Chile para Fundación Nodo XXI.
        </Typography>
      </Box>

      {/* Iconos sociales */}
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <IconButton color="black" href="https://www.facebook.com/Nodoxxi" target="_blank">
          <FacebookIcon />
        </IconButton>

        <IconButton color="black" href="https://x.com/NodoXXI" target="_blank">
          <XIcon />
        </IconButton>

        <IconButton color="black" href="https://www.instagram.com/nodoxxi/?hl=es" target="_blank">
          <InstagramIcon />
        </IconButton>

        <IconButton color="black" href="https://www.nodoxxi.cl/#" target="_blank">
          <RssFeedIcon />
        </IconButton>

        {/* Ícono </> que descarga el README */}
        <IconButton color="black" onClick={descargarReadme}>
          <CodeIcon />
        </IconButton>
      </Box>

      {/* Logo FES flotante */}
      <Box
        sx={{
          position: "absolute",
          top: "-70px",
          right: "40px",
          lineHeight: 0,
        }}
      >
        <img
          src="/img/FES-Logo_Standard_Rot_Bildschirm.png"
          alt="Logo FES"
          style={{ height: "100px", objectFit: "contain", display: "block" }}
        />
      </Box>
    </Box>
  );
};

export default Footer;
